import { Zap } from "lucide-react";

export function Logo() {
  return (
    <div className="flex items-center gap-2">
      <Zap className="size-8 text-[#4CAF50]" />
      <span className="text-2xl font-bold tracking-tight">VINCER</span>
    </div>
  );
}
